import { OpensearchPaginationCursorSchema } from "@redotech/redo-model/tables/table";
import { WarrantyRegistrationSchema } from "@redotech/redo-model/warranty-registration";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const getWarrantyRegistrations = {
  name: "getWarrantyRegistrations" as const,
  input: z.object({
    filters: z.record(z.string(), z.string()).nullish(),
    search: z.string().nullish(),
    skip: z.number().optional(),
    pageContinue: z.string().optional(),
    pageSize: z.number(),
    pageNumber: z.number().nullish(),
    sort: z
      .object({ key: z.string(), direction: createEnum(["asc", "desc"]) })
      .nullish(),
    opensearchToken: OpensearchPaginationCursorSchema.nullish(),
  }),
  output: z.object({
    data: z.array(WarrantyRegistrationSchema),
    pageNext: z.string().optional(),
    opensearchToken: OpensearchPaginationCursorSchema.nullish(),
  }),
};
